import React from 'react'
import { Heading, Text, Box } from 'rebass/styled-components'
import { Link } from 'gatsby'
import renderHTML from 'react-render-html'
import AnimationWrapper from '../helpers/Animations'
import MediaRender from '../components/general/MediaRender'

const Content = ({ options }) => {
    let content = null

    switch (options.type) {
    case 'person':
        content = (
            <AnimationWrapper type='fade-up'>
                <Link to={options.url}>
                    <MediaRender file={options.media.set[0]} alt={options.alt} />
                </Link>
                <Heading as="h3" variant="h2">{options.name}</Heading>
                <Text as="p" variant="paragraph" sx={{
                    color: 'aquaDark',
                }}>{options.role}</Text>
                <Text as="p" variant="paragraph">{renderHTML(options.description)}</Text>
                {options.url ? <Link className="text" to={options.url}>Read more</Link> : null}
                <br />
                {options.instagram ? <Link className="text" target="_blank" to={options.instagram}>Instagram</Link> : null}
            </AnimationWrapper>
        )
        break
    default:
        content = <Box variant="container"><Text variant="paragraph" color={ (options.color) ? options.color : '' }>{renderHTML(options.text)}</Text></Box>
    }

    return content
}

export default Content
